import { loadingSporsmalSteg } from './current-steg';
import { CurrentSporsmalAction } from './currentSporsmalReducer';
import {
    NextStepAction,
    PreviousStepAction,
    SporsmalsflytActionKeys,
    UpdateWithBesvarteSporsmalFromCacheAction,
} from './sporsmalsflyt-actions';
import {
    nextStep,
    previousStep,
    SporsmalsflytState,
    updateCurrentSporsmal,
    updateWithBesvarteSporsmalFromCache,
} from './sporsmalsflyt-state';
import { Sporsmal, SporsmalsGruppe } from './sporsmalsflyt-types';

export type SporsmalflytAction =
    | CurrentSporsmalAction
    | NextStepAction
    | PreviousStepAction
    | UpdateWithBesvarteSporsmalFromCacheAction
    | never;

export const initialSporsmalsflytState: SporsmalsflytState = {
    besvarteSporsmal: [],
    currentSteg: loadingSporsmalSteg(),
    next: [],
    forsikringIdentifikator: null,
};

export const sporsmalsflytReducer = (
    sporsmals: Sporsmal[],
    triggered: SporsmalsGruppe[],
    sporsmalsflytState: SporsmalsflytState = initialSporsmalsflytState,
    action: SporsmalflytAction = {} as SporsmalflytAction,
): SporsmalsflytState => {
    switch (action.type) {
        case SporsmalsflytActionKeys.NextStep:
            return nextStep(sporsmalsflytState, sporsmals, triggered, action.kundeinfo);

        case SporsmalsflytActionKeys.PreviousStep:
            return previousStep(sporsmalsflytState);

        case SporsmalsflytActionKeys.UpdateWithBesvarteSporsmalFromCacheAction:
            return updateWithBesvarteSporsmalFromCache(sporsmalsflytState, action.besvarteSporsmal);

        default:
            return updateCurrentSporsmal(sporsmalsflytState, action);
    }
};
